
import Auth from '../store/auth';
import Vue from 'vue';

const USER_URL = 'me';
export default {
    inserted(el,bindling){
    	//bindling.value为指令的绑定值
        let perVal = bindling.value;
        if(perVal){
            //hasPer为true为有权限
    		//hasPer为false为无权限
           if(Auth.state.user.Permissions && Auth.state.user.Permissions.length>0){
                let hasPer = Auth.state.user.Permissions.some((perm) => {
                    return perVal===(perm.Obj+'-'+perm.Act)
                });
                //没有权限就先隐藏此元素吧
                if(!hasPer){
                    el.style.display="none"
                }
            }else{//直接刷新页面，发现获取用户权限比加载页面慢，重新获取用户新，暂时这样处理，会出现同时多次获取用户新，不太好
                Vue.axios.get(USER_URL).then((response) => {
                    if(response.data && response.data.Permissions.length>0){
                        let hasPer = response.data.Permissions.some((perm) => {
                        return perVal===(perm.Obj+'-'+perm.Act)
                    });
                    //没有权限就先隐藏此元素吧
                    if(!hasPer){
                        el.style.display="none"
                    }
                }
                  }, ({ response }) => {
                    Vue.prototype.$sys.alarmResponse(response);
                  });
            }
        }
    }
}
